












































import { EventType } from '@/constants';
import { bus } from '@/main';
import { User } from '@/types';
import { buyerNameGenerator, getCoBuyers, standardCasing } from '@/util';
import Vue, { PropType } from 'vue';
import { mapGetters } from 'vuex';
export default Vue.extend({
  data () {
    return {
      collapsed: true
    };
  },
  props: {
    title: {
      type: String,
      required: true
    },
    buyerList: {
      type: Array as PropType<User[]>,
      default: () => [] as User[]
    },
    subTitle: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    count: {
      type: Number,
      default: 0
    },
    to: {
      type: String,
      default: ''
    },
    isExternalLink: {
      type: Boolean,
      default: false
    },
    isCollapsable: {
      type: Boolean,
      default: false
    },
    isMessage: {
      type: Boolean,
      default: false
    },
    isRecognizeATeamMember: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['selectedJob', 'isLoggedInAsAdmin']),
    coBuyerNames (): string {
      const coBuyers = getCoBuyers(this.selectedJob);
      return standardCasing(buyerNameGenerator(coBuyers));
    },
    cardTitle (): string {
      return standardCasing(this.title);
    }
  },
  methods: {
    navigate () {
      if (this.to && this.isExternalLink) {
        window.open(this.to, '_blank');
      } else if (this.to) {
        this.$router.push(this.to);
      }
    },
    toggleCardVisibility () {
      if (this.isCollapsable) {
        this.collapsed = !this.collapsed;
      }
    },
    handleIconClick () {
      if ((this.isRecognizeATeamMember && !this.isLoggedInAsAdmin) || !this.isRecognizeATeamMember) {
        this.navigate();
      } else {
        bus.$emit(EventType.VIEW_VERSION);
      }
    }
  }
});
